"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var styles_1 = require("@mui/material/styles");
var RAStyles_1 = require("@/Components/common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("@/Components/common/ReactAdmin/Pagination"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var inertia_1 = require("@inertiajs/inertia");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var material_1 = require("@mui/material");
var PrivateAccessModal_1 = __importDefault(require("../PrivateAccessModal"));
var IntegrationTemplateList = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    // const refresh = useRefresh();
    var _a = (0, react_1.useState)(false), snackbarOpen = _a[0], setSnackbarOpen = _a[1];
    var _b = (0, react_1.useState)(""), snackbarMessage = _b[0], setSnackbarMessage = _b[1];
    var page = (0, useTypedPage_1.default)();
    var _c = (0, react_1.useState)(false), privateAccessModalOpen = _c[0], setPrivateAccessModalOpen = _c[1];
    var _d = (0, react_1.useState)(null), selectedTemplateRecord = _d[0], setSelectedTemplateRecord = _d[1];
    var handleCopyId = function (e, id) {
        e.stopPropagation();
        navigator.clipboard.writeText(id);
        setSnackbarMessage("Integration Template Id ".concat(id, " Copied"));
        setSnackbarOpen(true);
    };
    var handleRowClick = function (record) {
        inertia_1.Inertia.visit("/integration-template-editor/".concat(record.id, "?version=").concat(record.current_version));
    };
    var handleOpenPrivateAccess = function (e, record) {
        e.stopPropagation();
        setSelectedTemplateRecord(record);
        setPrivateAccessModalOpen(true);
    };
    return (react_1.default.createElement("div", { style: { marginTop: "150px" } },
        react_1.default.createElement(react_admin_1.ListBase, { perPage: 100, resource: "integration-editor/templates", queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60,
            } },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                react_1.default.createElement(react_admin_1.Datagrid, { hover: false, bulkActionButtons: false, sx: RAStyles_1.RaOAuth2ClientDataGridSx, "data-cy": "integrationTemplateList", rowClick: function (_, __, record) {
                        handleRowClick(record);
                        return null;
                    } },
                    react_1.default.createElement(react_admin_1.FunctionField, { source: "id", label: t("ID"), render: function (record) { return (react_1.default.createElement("div", { onClick: function (e) { return handleCopyId(e, record.id); }, style: { cursor: "pointer" }, title: "Click to copy ID" }, record.id)); } }),
                    react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name") }),
                    react_1.default.createElement(react_admin_1.TextField, { source: "type", label: t("Type") }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Public"), render: function (record) { return (react_1.default.createElement("span", null, record.public ? "Public" : "Not Public")); } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Visibility"), render: function (record) { return (react_1.default.createElement("span", null, record.visible ? "Visible" : "Not Visible")); } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { source: "access", label: t("Access"), render: function (record) { return (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "8px" } },
                            react_1.default.createElement("span", null, record.public ? "All" : record.access),
                            !record.public && page.props.is_sysadmin && (react_1.default.createElement(material_1.Button, { onClick: function (e) { return handleOpenPrivateAccess(e, record); }, style: {
                                    padding: "0 5px",
                                    borderRadius: "5px",
                                    backgroundColor: "var(--secondary-color)",
                                    color: "var(--info-color)",
                                    maxWidth: "18px",
                                    minWidth: "18px",
                                    marginBottom: "5px"
                                }, size: "small" }, "+")))); } }),
                    react_1.default.createElement(react_admin_1.TextField, { source: "current_version", label: t("Version") }))),
            react_1.default.createElement(Pagination_1.default, { rowsPerPageOptions: [100, 250, 500, 1000] })),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: "success", snackbarStyle: {
                marginLeft: "110px",
            } }),
        privateAccessModalOpen && (react_1.default.createElement(PrivateAccessModal_1.default, { isShown: privateAccessModalOpen, onClose: function () { return setPrivateAccessModalOpen(false); }, type: "integration-template", resourceId: (selectedTemplateRecord === null || selectedTemplateRecord === void 0 ? void 0 : selectedTemplateRecord.id) || "", resourceName: selectedTemplateRecord === null || selectedTemplateRecord === void 0 ? void 0 : selectedTemplateRecord.name }))));
};
exports.default = IntegrationTemplateList;
